import { UserRepository, FollowRequestStatus } from '@amityco/js-sdk';
import useLiveObject from '../../core/hooks/useLiveObject';
const useFollowStatus = (sourceUserId, targetUserId) => {
    var _a;
    const followInfo = useLiveObject(() => UserRepository.getFollowInfo(sourceUserId, targetUserId), [sourceUserId, targetUserId]);
    return (_a = followInfo === null || followInfo === void 0 ? void 0 : followInfo.status) !== null && _a !== void 0 ? _a : FollowRequestStatus.None;
};
export default useFollowStatus;
//# sourceMappingURL=useFollowStatus.js.map